/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import { Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntegrationFactoryService {
  private viewerService = null;
  private risiService = null;
  constructor(private injector: Injector) {}

  async getViewer() {
    if (!this.viewerService) {
      const viewerIntegrationService = (await import('./viewer/viewer-integration.service')).ViewerIntegrationService;
      this.viewerService = this.injector.get(viewerIntegrationService).viewer;
    }
    return this.viewerService;
  }

  async getRISIService() {
    if (!this.risiService) {
      const risiService = (await import('./external-apps/riscv/riscv.service')).RISCVService;
      this.risiService = this.injector.get(risiService);
    }
    return this.risiService;
  }
}
